import React from "react";
import { useTranslation } from "react-i18next";
import { useParallax } from "react-scroll-parallax";

import { SectionIds } from "@constants/sectionIds";
import { contactLinks } from "@constants/contactLinks";
import { SKEY_NETWORK_PAGE } from "@constants/constants";

import ContactLink from "@components/toolkit/ContactLink/ContactLink";
import BaseLink from "@components/toolkit/BaseLink/BaseLink";
import ContactForm from "../ContactForm/ContactForm";

import "./Footer.scss";

const Footer = () => {
  const { t } = useTranslation(["landingPage"]);

  const { ref } = useParallax({
    speed: -15,
    scale: [1.05, 1, "easeOutCubic"]
  });

  return (
    <footer id={SectionIds.Footer} className="app-footer">
      <div className="app-footer-background">
        <img ref={ref as any} src="/images/layouts/footer-bg.jpg" alt="footer background image" className="bg-image" />
        <div className="bg-blur" />
      </div>

      <div className="app-footer-main">
        <h2 className="relative">{t("landingPage:footer.contact.title")}</h2>

        <div className="main-contact">
          <div className="contact-content">
            <p className="p0">{t("landingPage:footer.contact.description")}</p>

            <div className="contact-links mt-8">
              {contactLinks.map(({ label, href, target, icon }, index) => {
                return (
                  <ContactLink key={index} href={href} target={target}>
                    {icon} {label}
                  </ContactLink>
                );
              })}
            </div>
          </div>

          <div className="contact-form">
            <ContactForm />
          </div>
        </div>

        <div className="main-credentials">
          <div className="horizontal-line" />

          <div className="credentials-logos">
            <BaseLink href={SKEY_NETWORK_PAGE} target="_blank" className="p0">
              skey.network
            </BaseLink>

            <img src="/images/branding/skey-network-logo-white.svg" alt="Skey Network" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
